import React, { useEffect } from "react";
import "./bottomNav.css";

// Phone navigation (2026-11-03): the main places, always one tap away. Hidden on tablets and computers (see bottomNav.css),
// in the reader (no Navbar tabs there) and while filling in a Change of Name form, which needs the whole screen.
const PATHS = {
  home: "M4 11l8-7 8 7M6 10v10h4v-6h4v6h4V10",
  papers: "M4 5h13v14a1 1 0 0 0 1 1H6a2 2 0 0 1-2-2V5zM17 9h3v9a2 2 0 0 1-2 2M7.5 9h6M7.5 12.5h6M7.5 16h4",
  archive: "M4 4h16v4H4zM5.5 8v12h13V8M10 12h4",
  library: "M5 4h4v16H5zM10 4h4v16h-4zM15.5 4.5l3.5 1-4 15-3.5-1",
  account: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5c0-4 3.4-6 7.5-6s7.5 2 7.5 6",
};
const Icon = ({ d }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={d} /></svg>
);

export default function BottomNav({ currentRoute, filterType, signedIn, onHome, pickTab, browserRouter }) {
  const route = currentRoute || "";
  const hidden = /^\/(changeofname\/apply|change_of_name_tab)/.test(route);

  useEffect(() => {
    if (hidden) return undefined;
    document.body.classList.add("bn-on");
    return () => document.body.classList.remove("bn-on");
  }, [hidden]);

  if (hidden) return null;

  const top = () => window.scrollTo({ top: 0, behavior: "auto" });
  const to = (path) => { browserRouter(path); top(); };
  const items = [
    { key: "home", label: "Home", on: onHome && filterType !== "Newspaper", tap: () => { pickTab("all"); top(); } },
    { key: "papers", label: "Newspapers", on: onHome && filterType === "Newspaper", tap: () => { pickTab("Newspaper"); top(); } },
    { key: "archive", label: "Archive", on: /^\/archive/.test(route), tap: () => { pickTab("achive"); top(); } },
    { key: "library", label: "Library", on: /^\/account\/library/.test(route), tap: () => to(signedIn ? "/account/library" : "/login") },
    { key: "account", label: signedIn ? "Account" : "Sign in", on: /^\/account/.test(route) && !/^\/account\/library/.test(route), tap: () => to(signedIn ? "/account" : "/login") },
  ];

  return (
    <nav className="bn" aria-label="Main">
      {items.map((it) => (
        <button type="button" key={it.key} className={`bn-item${it.on ? " on" : ""}`} aria-current={it.on ? "page" : undefined} onClick={it.tap}>
          <Icon d={PATHS[it.key]} />
          <span>{it.label}</span>
        </button>
      ))}
    </nav>
  );
}
